import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import {
  ASK_ME_ASSISTANT,
  ASK_ME_USER,
  ASK_ME_WORKING_ON_RESPONSE,
} from 'src/app/components/projects/common/projects.constants';

@Component({
    selector: 'app-chat-message',
    imports: [CommonModule, MarkdownModule],
    templateUrl: './chat-message.component.html',
    styleUrl: './chat-message.component.scss'
})
export class ChatMessageComponent {
  @Input() text: string = '';
  @Input() sender: 'user' | 'assistant' = ASK_ME_USER;
  @Input() timestamp: Date = new Date();
  displayedText: string = '';
  workingOnResponseString: string = ASK_ME_WORKING_ON_RESPONSE;
  user: string = ASK_ME_USER;
  assistant: string = ASK_ME_ASSISTANT;
  private typingInterval: any;

  /**
   * Angular lifecycle hook that is called when any data-bound property of a directive changes.
   * Triggers the typing animation if the sender is the assistant and text is present.
   *
   * @param changes - The changed properties.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text'] || changes['sender']) {
      if (this.sender === this.assistant && this.text)
        this.startTypingAnimation();
      else {
        this.displayedText = this.escapeHtml(this.text);
        clearInterval(this.typingInterval);
      }
    }
  }

  /**
   * Escapes raw HTML angle-bracket/quote characters so chat text cannot be
   * rendered as HTML/markup by the <markdown> component. Markdown syntax
   * (e.g. **bold**, lists, links) does not use these characters, so
   * formatting is unaffected.
   */
  private escapeHtml = (value: string): string =>
    (value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

  /**
   * Animates the display of the message text one character at a time to simulate typing.
   */
  startTypingAnimation = (): void => {
    let currentIndex = 0;

    this.displayedText = '';
    clearInterval(this.typingInterval);
    const safeText = this.escapeHtml(this.text);

    this.typingInterval = setInterval(() => {
      if (currentIndex < safeText.length) {
        this.displayedText += safeText.charAt(currentIndex);
        currentIndex++;
      } else clearInterval(this.typingInterval);
    }, 10);
  };
}
